<template>
  <ul class="item_main">
    <li>
      <span>院系名称:</span>
      <p>{{ info.yxmc ? info.yxmc : "-" }}</p>
    </li>
    <li>
      <span>所在年级:</span>
      <p>{{ info.dqszj ? info.dqszj : "-" }}</p>
    </li>
    <li>
      <span>专业名称:</span>
      <p>{{ info.zymc ? info.zymc : "-" }}</p>
    </li>
    <li>
      <span>班级名称:</span>
      <p>{{ info.bjmc ? info.bjmc : "-" }}</p>
    </li>
    <li>
      <span>培养层次:</span>
      <p>{{ info.pyccm ? info.pyccm : "-" }}</p>
    </li>
    <li>
      <span>学&emsp;&emsp;制:</span>
      <p>{{ info.xz ? info.xz : "-" }}</p>
    </li>
    <li>
      <span>学籍状态:</span>
      <p>{{ info.newxjzt ? info.newxjzt : "-" }}</p>
    </li>
    <li>
      <span>在校状态:</span>
      <p>{{ info.xjzt ? info.xjzt : "-" }}</p>
    </li>
    <li>
      <span>当前状态:</span>
      <p>{{ info.xsdqzt ? info.xsdqzt : "-" }}</p>
    </li>
    <li>
      <span>毕业专业:</span>
      <p>{{ info.oldbyzy ? info.oldbyzy : "-" }}</p>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/newPages/teacher/xjydsh/mode/modeXsdqqk.vue